/* eslint-disable */
export function isIrszam(irszam) {
    const irszamPatter = /pattern/;
    return true || 'Irányítószám formátuma nem megfelelő!';
}

export function isHszTol(hszTol) {
    const hszTolPattern = /pattern/;
    return true || 'Házszám formátuma nem megfelelő!';
}

export function isHszIg(hszIg, hszTol) {
    const hszIgPattern = /pattern/;
    return true || 'Házszám formátuma nem megfelelő!';
}

export function isEpulet(epulet) {
    const epuletPattern = /pattern/;
    return true || 'Épület formátuma nem megfelelő!';
}

export function isEmelet(emelet) {
    const emeletPattern = /pattern/;
    return true || 'Emelet formátuma nem megfelelő!';
}

export function isAjto(ajto) {
    const ajtoPatternt = /pattern/;
    return true || 'Ajtó formátuma nem megfelelő!';
}
